<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Vevői számla tételek</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20" type="flex" justify="around">
          <el-col :span="16" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="handleChange"
              />
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Vevő"
            >
              <el-select
                v-model="customer"
                filterable
                remote
                :remote-method="searchCustomer"
                :loading="customerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="handleChange"
                clearable
              >
                <el-option
                  v-for="p in customers"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Beszállító"
            >
              <el-select
                v-model="supplier"
                filterable
                remote
                :remote-method="searchSupplier"
                :loading="supplierLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="handleChange"
                clearable
              >
                <el-option
                  v-for="p in suppliers"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-row type="flex" justify="end" style="margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
              <el-button
                :loading="printLoading"
                icon="el-icon-printer"
                @click="print"
              >
                Nyomtatás
              </el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :data="data.data"
        style="width: 100%"
        row-key="id"
        border
      >
        <el-table-column
          prop="count"
          label="Teljesítés"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.delivery_date }}
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="count"
          label="Számlaszám"
        >
          <template slot-scope="scope">
            {{ scope.row.invoice_number }}
          </template>
        </el-table-column>

        <el-table-column
          prop="supplier_name"
          label="Gyártó"
          show-overflow-tooltip
        >
        </el-table-column>


        <el-table-column
          prop="product_name"
          label="Termék"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="count"
          label="Mennyiség (darab)"
          width="100"
          align="right"
        >
        </el-table-column>

        <el-table-column
          prop="unit_price"
          label="Egységár"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.unit_price | currency }}
          </template>
        </el-table-column>

        <el-table-column
          prop="net_price"
          label="Nettó"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.net_price | currency }}
          </template>
        </el-table-column>

        <el-table-column
          prop="vat"
          label="Áfakulcs"
          align="right"
        >
        </el-table-column>

      </el-table>

      <div class="el-card-footer">
        <el-pagination
          background
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="data.per_page"
          layout="total, prev, pager, next"
          :total="data.total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
  import moment from 'moment';
  import {saveAs} from 'file-saver';


  export default {
    components: {},
    data() {
      const start = moment()
        .startOf('year')
        .format('Y-MM-DD');
      const end = moment()
        .format('Y-MM-DD');
      return {
        data: {},
        loading: false,
        currentPage: 1,
        downloadLoading: false,
        printLoading: false,
        suppliers: [],
        customers: [],
        customer: null,
        supplier: null,
        supplierLoading: false,
        customerLoading: false,
        dateRange: [start, end],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment()
                .weekday(1)
                .toDate();
              const end = moment()
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment()
                .subtract({weeks: 1})
                .weekday(1)
                .toDate();
              const end = moment()
                .subtract({weeks: 1})
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 1})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 3})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment()
                .subtract({years: 1})
                .startOf('year')
                .toDate();
              const end = moment()
                .subtract({years: 1})
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {},
    watch: {},
    async mounted() {
      this.fetchData();
    },
    methods: {
      async download() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: `api/reports/invoice-items/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              from: this.dateRange[0],
              to: this.dateRange[1],
              customer_id: this.customer ? this.customer.id : null,
              supplier_id: this.supplier ? this.supplier.id : null,
            },
          });
          saveAs(excel, `invoiceitems.xlsx`);
        } catch (e) {
        }
        this.downloadLoading = false;
      },

      async print() {
        this.printLoading = true;
        const response = await axios.post('api/reports/invoice-items/print', {
          from: this.dateRange[0],
          to: this.dateRange[1],
          customer_id: this.customer ? this.customer.id : null,
          supplier_id: this.supplier ? this.supplier.id : null,
        }, {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/pdf'
          },
        });
        this.printLoading = false;

        const newBlob = new Blob([response], {type: 'application/pdf'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
      },

      async fetchData() {
        this.loading = true;
        let query = `api/reports/invoice-items?page=${this.currentPage}&from=${this.dateRange[0]}&to=${this.dateRange[1]}`

        if (this.customer) {
          query += `&customer_id=${this.customer.id}`
        }

        if (this.supplier) {
          query += `&supplier_id=${this.supplier.id}`
        }

        this.data = await axios.get(query);
        this.loading = false;
      },

      async searchCustomer(query) {
        if (query !== '') {
          this.customerLoading = true;
          this.customers = await this.$store.dispatch('partner/search', '?name=' + query + '&type=customer');
          this.customerLoading = false;
        }
      },

      async searchSupplier(query) {
        if (query !== '') {
          this.supplierLoading = true;
          this.suppliers = await this.$store.dispatch('partner/search', '?name=' + query + '&type=supplier');
          this.supplierLoading = false;
        }
      },

      handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchData();
      },


      handleChange() {
        this.currentPage = 1;
        this.fetchData();
      }
    },
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
